/**
 * Color Schemes
 */

export function getColorSchemeClassName(scheme?: ColorScheme, prefix?: string) {
  return scheme ? `${prefix ? `${prefix}-` : ''}color-scheme--${scheme}` : '';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/styles/color-schemes.ts